<template>
  <ButtonSquare
    :size="setSize"
    :activeState="activeState"
    @clicked="onClick"
    @mouseenter="$emit('mouseenter')"
    @mouseleave="$emit('mouseleave')"
  >
    <p
      v-if="hasCharacter"
      class="button-square__p"
      :class="{
        'button-square__p__active': activeState === 'active',
        'button-square__p__deactivated': activeState === 'deactivated'
      }"
    >
      {{ character }}
    </p>
  </ButtonSquare>
</template>

<script>
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'
export default {
  name: 'ButtonSquareNoIcon',
  components: { ButtonSquare },
  props: {
    activeState: {
      type: String,
      default: 'inactive',
      validator: (value) => {
        return ['inactive', 'active', 'deactivated'].indexOf(value) !== -1
      }
    },
    isDarkMode: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'medium',
      validator: (value) => {
        return ['small', 'medium', 'large'].indexOf(value) !== -1
      }
    },
    character: {
      type: [Number, String],
      default: ''
    }
  },
  emits: ['clicked', 'mouseenter', 'mouseleave'],
  computed: {
    hasCharacter() {
      return this.size === 'small' && this.character
    },
    hasTitle() {
      return this.size === 'large' && this.title
    },
    setSize() {
      if (this.hasCharacter) {
        return 'small'
      } else {
        return this.size.default
      }
    }
  },
  methods: {
    onClick() {
      this.$emit('clicked', this.character)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/variables.scss';
.button-square {
  padding: 0;
  &--text {
    padding: 0;
  }
  &__p {
    color: $color-text-grey;
    font-family: $font-family-secondary;
    line-height: 0;
    font-size: 16px;
    font-weight: bold;
    margin: 0;
    &__active {
      color: $color-text-white-70;
    }
    &__deactivated {
      color: $color-grey;
    }
  }
}
</style>
